import React, { Component } from 'react';
import Chart from 'react-apexcharts';

class ColumnChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.chartData,
      chartOptions: this.props.chartOptions,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value || prevProps.chartData !== this.props.chartData) {
      this.setState({
        chartData: this.props.chartData,
        chartOptions: this.props.chartOptions,
      });
    }
  }

  render() {
    const { chartData } = this.state;

    const validData =
      Array.isArray(chartData) &&
      chartData.length > 0 &&
      chartData.every((series) => Array.isArray(series.data));

    if (!validData) {
      return null;
    }

    return (
      <Chart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type='bar'
        width='100%'
        height='100%'
      />
    );
  }
}

export default ColumnChart;
